// src/api/createAxiosInstance.ts
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

interface CreateAxiosOptions {
  baseURL: string;
  timeout?: number;
  withAuth?: boolean;
}

const createAxiosInstance = ({ baseURL, timeout = 0, withAuth = true }: CreateAxiosOptions): AxiosInstance => {
  const instance = axios.create({
    baseURL,
    timeout,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  // Request Interceptor
  instance.interceptors.request.use(
    async config => {
      if (withAuth) {
        const token = sessionStorage.getItem('token');
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
          config.headers.AuthorizationData = token;
        }
      }
      // Remove Content-Type if data is FormData
      if (
        config.data &&
        typeof config.data === 'object' &&
        (config.data instanceof FormData || config.data._boundary)
      ) {
        delete config.headers['Content-Type'];
        config.headers['Content-Type'] = 'multipart/form-data';
      }
      return config;
    },
    error => Promise.reject(error)
  );

  // Response Interceptor
  instance.interceptors.response.use(
    response => response,
    error => {
      if (error.response?.status === 401) {
        console.warn('❌ Unauthorized! Token may be expired.');
        // Optionally refresh token or navigate to login
        // Attach a custom message for 401 errors
        error.customMessage = 'Session expired or unauthorized. Please login again.';
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

export default createAxiosInstance;
